module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "preface"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8"
    }
  }, [_c('strong', [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('img', {
    staticClass: "in100",
    attrs: {
      "alt": "Image",
      "src": "images/bar.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I was approached to write this book, my initial thought was, “Quick Pickles? "), _c('em', [_vm._v("Really?")]), _vm._v(" Sure, I like making pickles, but is there enough variety to fill a book? And, if so, how can I make "), _c('em', [_vm._v("this")]), _vm._v(" book different from every other pickle book out there?” Well, of course, upon greater consideration, I realized, yeah, there are a "), _c('em', [_vm._v("ton")]), _vm._v(" of pickles to fill a book. And, what sets "), _c('em', [_vm._v("this")]), _vm._v(" one apart from the rest is the discovery, along the way, of how pervasive pickles are in everyday cooking. This isn’t merely a pack-your-cukes-into-a-jar-end-of-story kind of story. Rather, it’s a how-to-showcase-all-those-delicious-pickles-that-you’ve-just-made kind of story—pickle juice included.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("That’s")]), _vm._v(" the story I wanted to tell. Here’s one scenario: You’ve made a batch or two of awesome pickles, and maybe eaten a good portion of them. But there’s about half a jar of stragglers and all that tangy pickle juice left. Do you toss it to make room for something else in your fridge? I certainly hope not. Chop some dill pickles and add them "), _c('em', [_vm._v("and")]), _vm._v(" some brine to a "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01sub02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Russian Beef Barley Soup with Pickles called "), _c('em', [_vm._v("Rassolnik")])]), _vm._v(". Or use half of your Fire-Roasted Pickled Baby Bells in an amazing "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01sub37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spanish "), _c('em', [_vm._v("Romesco")]), _vm._v(" sauce")]), _vm._v(". Or purée some Pickled Sweet Beets with Pearl Onions into a "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01sub12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Super Quick Borscht")]), _vm._v(". These are just a few of the recipes that use pickles and their brine to create a completely new dish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Then there are the myriad ways to use the pickles themselves: Cram some "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch01#ch01sub33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled Red Cabbage with Horseradish and Caraway")]), _vm._v(" into an ooey gooey grilled cheese sandwich. Or serve "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02sub17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crunchy Pickled Pears with warm")]), _vm._v(", baked Camembert. Or mash some "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02sub01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon-Pickled Blackberries")]), _vm._v(" into whipped cream and crushed meringues for an awesome Eton mess.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("One other thing I wanted to point out is that in these pickle recipes, the brine is as important as the produce. And, in many cases, the brine is the star of another, separate recipe. The "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02sub23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple-Aperol Spritz")]), _vm._v(", for example, uses the tropical-flavored, sweet-tart brine as the base for a cocktail, and the pineapple itself is only a garnish. The brine alone from the "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02sub07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickled Plums")]), _vm._v(" becomes a tart and "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch02sub08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("refreshing granita")]), _vm._v(". Both totally unexpected and totally delicious. Unlike the "), _c('em', [_vm._v("pickleback")]), _vm._v(" (a shot of pickle juice after a shot of whiskey) the pickles here aren’t an afterthought, a side-attraction, or a dare. They’re the main event—and the only dare is to make them and not love them. I hope you’ll try to prove me wrong.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5c2a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 72
// module chunks = 0